// Szegmensek (UI-4): the list, a new segment, and one segment — three screens
// under one address, so App.tsx names the section once (`/szegmensek/*`).
//
//   /szegmensek                     the list (?orszag=HU, ?nezet=archivalt, ?q=)
//   /szegmensek/uj                  a new segment (?orszag=, ?masolat=<id>)
//   /szegmensek/:id                 one segment: its conditions, count and build

import { Route, Routes, useParams } from "react-router-dom";
import { PageHeader } from "@/components/emc/PageHeader";
import { ErrorState } from "@/components/emc/states";
import SegmentBuilder from "@/pages/segments/SegmentBuilder";
import SegmentList from "@/pages/segments/SegmentList";

function OneSegment() {
  const { id } = useParams();
  const segmentId = Number(id);
  if (!/^\d+$/.test(id ?? "") || !Number.isSafeInteger(segmentId)) {
    return (
      <>
        <PageHeader title="Szegmens" back={{ to: "/szegmensek", label: "Szegmensek" }} />
        <ErrorState message="Nincs ilyen szegmens. Menj vissza a listához." />
      </>
    );
  }
  // A new key per id: another segment is another page, not an edit of this one.
  return <SegmentBuilder key={segmentId} segmentId={segmentId} />;
}

export default function Segments() {
  return (
    <Routes>
      <Route index element={<SegmentList />} />
      <Route path="uj" element={<SegmentBuilder key="new" segmentId={null} />} />
      <Route path=":id" element={<OneSegment />} />
    </Routes>
  );
}
